var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquigglyBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 195,
    viewBox: "0 0 256 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8929_838)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 0H27V5H24V0H11V5H7V0H0V7H5V11H0V24H6V28H0V68H2V30H8V22H1.83346V13H5V19H13V13H19.0315V5H13V2H21.8192V7H29V2H118V0ZM13 11H17.198V7H13V11ZM7 11H11V7H7V11ZM7 17H11V13H7V17ZM2 5H5V2H2V5Z",
    fill: "url(#paint0_linear_8929_838)",
    style: {
      mixBlendMode: "overlay"
    },
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 0H229V5H232V0H245V5H249V0H256V7H251V11H256V24H250V28H256V68H254V30H248V22H254.167V13H251V19H243V13H236.969V5H243V2H234.181V7H227V2H118V0ZM243 11H238.802V7H243V11ZM249 11H245V7H249V11ZM249 17H245V13H249V17ZM254 5H251V2H254V5Z",
    fill: "url(#paint1_linear_8929_838)",
    style: {
      mixBlendMode: "overlay"
    },
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 194H27V189H24V194H11V189H7V194H0V187H5V183H0V170H6V166H0V68H2V164H8V172H1.83346V181H5V175H13V181H19.0315V189H13V192H21.8192V187H29V192H119V194ZM13 183H17.198V187H13V183ZM7 183H11V187H7V183ZM7 177H11V181H7V177ZM2 189H5V192H2V189Z",
    fill: "url(#paint2_linear_8929_838)",
    style: {
      mixBlendMode: "overlay"
    },
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 194H229V189H232V194H245V189H249V194H256V187H251V183H256V170H250V166H256V68H254V164H248V172H254.167V181H251V175H243V181H236.969V189H243V192H234.181V187H227V192H119V194ZM243 183H238.802V187H243V183ZM249 183H245V187H249V183ZM249 177H245V181H249V177ZM254 189H251V192H254V189Z",
    fill: "url(#paint3_linear_8929_838)",
    style: {
      mixBlendMode: "overlay"
    },
    shapeRendering: "crispEdges"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8929_838",
    x: 0,
    y: 0,
    width: 256,
    height: 195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8929_838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8929_838",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8929_838",
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8929_838",
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8929_838",
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8929_838",
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3529"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquigglyBorder);
export default ForwardRef;